import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Trophy } from "lucide-react";
import { EmptyState } from "./Common";
import { api } from "../lib/api";

const MEDAL = ["bg-amber-400 text-slate-950", "bg-slate-300 text-slate-900", "bg-orange-300 text-slate-900"];

export function ReviewRanking({ start, end }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/reviews/ranking", { params: { start: start || undefined, end: end || undefined } }).then((r) => setRows(r.data)); }, [start, end]);
  if (!rows) return null;
  const max = rows[0]?.count || 1;

  return (
    <section className="mt-10" data-testid="review-ranking">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-lg font-bold text-slate-900 flex items-center gap-2"><Trophy className="h-5 w-5 text-amber-500" />Ranking Review Driver</h2>
        <Link to="/admin/reviews" className="text-sm font-semibold text-emerald-700 hover:underline" data-testid="ranking-see-reviews">Lihat review</Link>
      </div>
      {rows.length ? (
        <div className="rounded-2xl border border-slate-200 bg-white divide-y divide-slate-100">
          {rows.map((r, i) => (
            <div key={r.driver_id} className="rise flex items-center gap-4 px-5 py-4" style={{ animationDelay: `${i * 40}ms` }} data-testid={`ranking-row-${r.driver_id}`}>
              <span className={`h-9 w-9 shrink-0 rounded-full grid place-items-center font-heading font-bold text-sm ${MEDAL[i] || "bg-slate-100 text-slate-500"}`} data-testid={`ranking-pos-${r.driver_id}`}>{i + 1}</span>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-900 truncate">{r.driver_name}</p>
                <div className="h-1.5 bg-slate-100 rounded-full mt-2 overflow-hidden"><div className="h-full bg-pink-500 rounded-full transition-[width] duration-700" style={{ width: `${(r.count / max) * 100}%` }} /></div>
              </div>
              <span className="flex items-center gap-1 font-num font-bold text-slate-900" data-testid={`ranking-count-${r.driver_id}`}><Star className="h-4 w-4 fill-amber-400 text-amber-400" />{r.count}</span>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState title="Belum ada review" text="Belum ada review tamu pada periode ini." testId="empty-ranking" />
      )}
    </section>
  );
}
